import { render } from "./PatientListing.vue?vue&type=template&id=141c733c&scoped=true&ts=true"
import script from "./PatientListing.vue?vue&type=script&lang=ts"
export * from "./PatientListing.vue?vue&type=script&lang=ts"

import "./PatientListing.vue?vue&type=style&index=0&id=141c733c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-141c733c"]])

export default __exports__